import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class WarehouseReferenceService extends BaseReferenceService {
  constructor() {
    super('WarehouseReference');
  }
}
